import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mobo-dropdown',
  templateUrl: './dropdown.component.html',
  styles: [],
})
export class DropdownComponent {
  private _options!: any[];
  public get options(): any[] {
    return this._options;
  }
  @Input()
  public set options(v: any[]) {
    this._options = v;
    if (this.selectedValue) {
      this.selectedValue = this.selectedValue;
    }
  }

  @Input() value?: any;
  @Input() description?: any;
  @Input() label?: string = 'Escolha uma Opção';

  private _selectedValue: any;
  public get selectedValue(): any {
    return this._selectedValue;
  }
  @Input()
  public set selectedValue(v: any) {
    this._selectedValue = v;
    const option = this.options?.find((x) => x[this.value] == v);
    if (option) {
      this.selectedOption = { ...option };
    }
  }
  @Output() change = new EventEmitter();
  public selectedOption?: any;
  public isDropdownOpen: boolean = false;

  public toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  public chooseOption(value: any) {
    this.toggleDropdown();
    const option = this.options?.find((x) => x[this.value] == value);
    if (option) {
      this.selectedOption = { ...option };
      this.change.emit({ ...option });
    }
  }
}
